import { useEffect, useState } from "react";

export const useAsyncKeenSlider = () => {
  const [KeenSlider, setKeenSlider] = useState<typeof import("keen-slider")["default"] | null>(null);

  useEffect(() => {
    let mounted = true;

    import("keen-slider").then((mod) => {
      if (mounted) setKeenSlider(() => mod.default);
    });

    return () => {
      mounted = false;
    };
  }, []);

  return KeenSlider;
};
